// 引入 echarts核心模块
import echarts from "echarts/lib/echarts";

// 引入你需要使用的图表类型以及应用到的组件
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/map'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/geo'
import 'echarts/lib/component/visualMap'

// 导出
export default echarts;